import Page from 'classes/Page'
import ContactsFn from './functions'

export default class Contacts extends Page {
  constructor() {
    super({
      id: 'contacts',
      element: '.contacts',
      elements: {
        header: document.querySelector('.header'),
        intro: '.contacts_intro'
      }
    })

    if (document.getElementsByClassName(this.id).length > 0) {
      this.pageFn()
    }
  }

  pageFn() {
    return new ContactsFn()
  }
}
